import * as React from "react";
import moment from "moment";
import {
    getFormattedAddress,
    isNullOrWhitespace,
} from "../../services/stringService";

export const RetrocheckFacesheetPatientHistory = ({patients}) => {
    return (
        <div className="facesheet-personal">
            {patients && patients?.map(x => (
                <li className="facesheet-history__item" key={x.templateKey}>
                    <div className="facesheet-personal__info">
                        <div className="facesheet-personal__left">
                            <div className="facesheet-personal__info-item">
                                <span className="p-regular">
                                    <span className="h5">Account ID </span>
                                    <span className="p-regular">{x.clientPatientId}</span>
                                </span>
                            </div>
                        
                            <div className="facesheet-personal__info-item">
                                <span className="h5">Date Of Admission </span>
                                <span className="p-regular">
                                    {x.dateOfAdmission}
                                </span>
                            </div>
                            <div className="facesheet-personal__info-item">
                                <span className="p-regular">
                                    <span className="h5">Total Service And Medical Charges </span>
                                    {x.totalBill}
                                </span>
                            </div>
                        </div>
                        {/* Need to get deductable and copay*/}
                        <div className="facesheet-personal__right">
                            <div className="facesheet-personal__info-item">
                                <span className="h5">Date Of Release </span>
                                <span className="p-regular">{x.dateOfDischarge}</span>
                            </div>
                            <div className="facesheet-personal__info-item">
                                <span className="h5">Status </span>
                                <span className="p-regular">{isNullOrWhitespace(x.totalBill)?"Paid":"Payment Pending"}</span>
                            </div>
                        </div>
                    </div>
                </li>
            ))}
            
        </div>
    );
};
